import validator from "validator";
import message from "../../../messages/position";

const validateCount = (count) => {
  if (validator.isEmpty(count)) {
    return message.COUNT_DOSE_NOT_EXIST;
  }

  if (!validator.isNumeric(count)) {
    return message.COUNT_INVALID;
  }

  return true;
};

const validateHeight = (height) => {
  if (validator.isEmpty(height)) {
    return message.HEIGHT_DOSE_NOT_EXIST;
  }

  if (!validator.isNumeric(height)) {
    return message.HEIGHT_INVALID;
  }

  return true;
};

const validateWidth = (width) => {
  if (validator.isEmpty(width)) {
    return message.WIDTH_DOSE_NOT_EXIST;
  }

  if (!validator.isNumeric(width)) {
    return message.WIDTH_INVALID;
  }

  return true;
};

const validatePrice = (price) => {
  if (validator.isEmpty(price)) {
    return message.PRICE_DOSE_NOT_EXIST;
  }

  if (!validator.isNumeric(price)) {
    return message.PRICE_INVALID;
  }

  return true;
};

const validateAlternativePrice = (alternativePrice) => {
  if (validator.isEmpty(alternativePrice)) {
    return message.ALTERNATIVE_PRICE_DOSE_NOT_EXIST;
  }

  if (!validator.isNumeric(alternativePrice)) {
    return message.ALTERNATIVE_PRICE_INVALID;
  }

  return true;
};

const validateBasePrice = (basePrice) => {
  if (validator.isEmpty(basePrice)) {
    return message.BASE_PRICE_DOSE_NOT_EXIST;
  }

  if (!validator.isNumeric(basePrice)) {
    return message.BASE_PRICE_INVALID;
  }

  return true;
};

const validateFormAddPosition = (info) => {
  const resValidateCount = validateCount(info.count);
  if (resValidateCount != true) {
    return resValidateCount;
  }

  const resValidateBasePrice = validateBasePrice(info.base_price);
  if (resValidateBasePrice != true) {
    return resValidateBasePrice;
  }

  const resValidatePrice = validatePrice(info.price);
  if (resValidatePrice != true) {
    return resValidatePrice;
  }

  const resValidateAlternativePrice = validateAlternativePrice(
    info.alternative_price
  );
  if (resValidateAlternativePrice != true) {
    return resValidateAlternativePrice;
  }

  const resValidateHeight = validateHeight(info.height);
  if (resValidateHeight != true) {
    return resValidateHeight;
  }

  const resValidateWidth = validateWidth(info.width);
  if (resValidateWidth != true) {
    return resValidateWidth;
  }

  return true;
};

export default validateFormAddPosition;
